import { request } from '@/api/httpClient'

export async function visualisationListImages(contactId) {
  return request({
    method: 'visualisation/ListImages',
    payload: {
      OnlyForThisContactId: contactId
    }
  })
}

export async function visualisationUpdateImage(id, reference, view) {
  return request({
    method: 'visualisation/UpdateImage',
    payload: {
      Id: id,
      Reference: reference,
      InternalView: view
    }
  })
}

export async function visualisationDeleteImage(id) {
  return request({
    method: 'visualisation/DeleteImage',
    payload: {
      Id: id
    }
  })
}

export async function visualisationUpdateImageForm(newDocument) {
  return request({
    method: 'visualisation/UpdateImageForm',
    payload: newDocument
  })
}
